/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OSDiscountCodeDto
 */
export interface OSDiscountCodeDto {
    /**
     * 
     * @type {string}
     * @memberof OSDiscountCodeDto
     */
    discountCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof OSDiscountCodeDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OSDiscountCodeDto
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof OSDiscountCodeDto
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OSDiscountCodeDto
     */
    validFrom: string;
}

/**
 * Check if a given object implements the OSDiscountCodeDto interface.
 */
export function instanceOfOSDiscountCodeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "discountCode" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "deleted" in value;
    isInstance = isInstance && "validFrom" in value;

    return isInstance;
}

export function OSDiscountCodeDtoFromJSON(json: any): OSDiscountCodeDto {
    return OSDiscountCodeDtoFromJSONTyped(json, false);
}

export function OSDiscountCodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OSDiscountCodeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'discountCode': json['discountCode'],
        'active': json['active'],
        'deleted': json['deleted'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : json['expirationDate'],
        'validFrom': json['validFrom'],
    };
}

export function OSDiscountCodeDtoToJSON(value?: OSDiscountCodeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'discountCode': value.discountCode,
        'active': value.active,
        'deleted': value.deleted,
        'expirationDate': value.expirationDate,
        'validFrom': value.validFrom,
    };
}

